import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, from, switchMap, throwError } from 'rxjs';

import { KeycloakAuthService } from './keycloak-auth.service';

const IDEMPOTENT = new Set(['GET', 'HEAD', 'OPTIONS']);

export const keycloakAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakAuthService);
  return from(keycloak.getToken()).pipe(
    switchMap((token) => {
      const authed = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;
      return next(authed).pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status !== 401 || !IDEMPOTENT.has(req.method.toUpperCase())) {
            return throwError(() => err);
          }
          return from(keycloak.forceRefresh()).pipe(
            switchMap((fresh) =>
              fresh
                ? next(
                    req.clone({
                      setHeaders: { Authorization: `Bearer ${fresh}` },
                    })
                  )
                : throwError(() => err)
            )
          );
        })
      );
    })
  );
};
